export default "__VITE_ASSET__709d5cfc__"